var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.749902 10.3248C0.599902 10.3248 0.449902 10.2748 0.349902 10.1498C0.124902 9.9248 0.124902 9.57481 0.349902 9.34981L7.9249 1.7748H1.8749C1.5749 1.7748 1.3249 1.5248 1.3249 1.2248C1.3249 0.924805 1.5749 0.674805 1.8749 0.674805H9.2499C9.5499 0.674805 9.7999 0.924805 9.7999 1.2248V8.6498C9.7999 8.9498 9.5499 9.1998 9.2499 9.1998C8.9499 9.1998 8.6999 8.9498 8.6999 8.6498V2.6248L1.1499 10.1748C1.0499 10.2748 0.899902 10.3248 0.749902 10.3248Z",
    fill: "#0092CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg16);
export default __webpack_public_path__ + "static/media/svg16.c110a2c998041ad9308513bd92bc2ad3.svg";
export { ForwardRef as ReactComponent };